import AboutMeSection from './components/AboutMeSection';
import ContactSection from './components/ContactSection';
import CoursesSection from './components/CoursesSection';
import Header from './components/Header';
import Home from './components/Home';
import Services from './components/Services';
import SlideSection from './components/SlideSection';
import PriceSection from './components/PriceSection';
import './styles/main.scss';
function App() {
  return (
    <>
      {' '}
      <Header />
      <div className="body">
        <Home />
        <SlideSection />
        <AboutMeSection />
        <Services />
        <PriceSection />
        <CoursesSection />
      </div>
      <ContactSection />
    </>
  );
}

export default App;
